module.exports = __webpack_public_path__ + "0fce9afb296662e3d721178681bcb79a.MP3";